import { createContext } from "react";

export const ScreenStatusContext = createContext({});